/**
 * Переключение темы — полностью клиентское.
 *
 * Сохраняет выбор в localStorage['theme'] ('dark' | 'light') и в `data-theme`
 * на <html>. Также синхронизирует флаг `user.them` (legacy: true=светлая,
 * false=тёмная), чтобы старые компоненты (Header/Menu/Layout с *.W.scss
 * вариантами) тоже отреагировали.
 *
 * Возвращает promise со стандартным axios-подобным `{ data: { them } }`,
 * чтобы существующие места `dispatch(changeThemeAction(response.data))`
 * не пришлось переписывать.
 */
export const ChangeTheme = () => {
  const root = document.documentElement
  const current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light'
  const next = current === 'dark' ? 'light' : 'dark'

  if (next === 'dark') root.setAttribute('data-theme', 'dark')
  else root.removeAttribute('data-theme')

  try {
    localStorage.setItem('theme', next)
  } catch (_) {
    /* ignore */
  }

  // legacy: user.them — true = светлая, false = тёмная
  const them = next === 'light'
  try {
    const raw = localStorage.getItem('user')
    if (raw) {
      const u = JSON.parse(raw)
      u.them = them
      if (u.userInfo && typeof u.userInfo === 'object') {
        u.userInfo.them = them
      }
      localStorage.setItem('user', JSON.stringify(u))
    }
  } catch (_) {
    /* ignore */
  }

  return Promise.resolve({ data: { them } })
}
